@if (data.workflow) {
  <div class="task">
    <h2>
      <a uiSref="a.workflow.detail" [uiParams]="{id: data.workflow.id}" ngbTooltip="Zurück zum Vorgang">
        <i class="fa fa-chevron-left"></i>
        Vorgang: {{ data.workflow.id }}
        <!-- We need to explicitly write "last" offer since: https://git.envisia.de/erp/loki/issues/448 -->
        letztes Angebot: {{ data.lastOffer?.id }} vom {{ data.lastOffer?.date }}
      </a>
    </h2>
    <h1>Auftrag aus Angebot</h1>
    Zu bestätigende Position aus Angebot wählen<br><br>
    <div>
      <table class="table whitetable">
        <thead>
          <tr>
            <th style="text-align: left; width: 200px;">Bezeichnung</th>
            <th>Menge</th>
            @if (valid('de')) {
              <th class="storzgreen">Lose</th>
            }
            @if (valid('de')) {
              <th class="storzgreen">Freigabe</th>
            }
            @if (valid('de')) {
              <th class="storzgreen bold">Einzel DE</th>
            }
            @if (valid('cn')) {
              <th class="storzblue">Lose CHN</th>
            }
            @if (valid('cn')) {
              <th class="storzblue">Freigabe</th>
            }
            @if (valid('cn')) {
              <th class="storzblue bold">Einzel CHN</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (position of filteredPositions; track position) {
            <tr>
              <td class="alri">
                <label>
                  {{ position.description }}
                </label>
                @if (position.desextension) {
                  <div>
                    <label>
                      {{ position.desextension }}
                    </label>
                  </div>
                }
              </td>
              <td class="alri">
                <label>
                  {{ position.quanity }}
                </label>
              </td>
              @if (valid('de')) {
                <td class="alri" [ngClass]="{selected: check(position, 'de')}"
                  (click)="select(position, 'de')">
                  <label>
                    {{ position.lose_de }}
                  </label>
                </td>
              }
              @if (valid('de')) {
                <td class="alri" [ngClass]="{selected: check(position, 'de')}"
                  (click)="select(position, 'de')">
                  <label>
                    {{ position.release_de }}
                  </label>
                </td>
              }
              @if (valid('de')) {
                <td class="alri bold" [ngClass]="{selected: check(position, 'de')}"
                  (click)="select(position, 'de')">
                  <label [ngClass]="{'red-font': !position.valid_de}">
                    @if (!position.valid_de) {
                      <i class="fa fa-warning"></i>
                    }
                    {{ position.de.price }}
                    @if (position.de) {
                      <span>€</span>
                    }
                  </label>
                </td>
              }
              @if (valid('cn')) {
                <td class="alri" [ngClass]="{selected: check(position, 'cn')}"
                  (click)="select(position, 'cn')">
                  <label [ngClass]="{'red-font': !position.valid_cn}">
                    {{ position.lose_cn }}
                  </label>
                </td>
              }
              @if (valid('cn')) {
                <td class="alri" [ngClass]="{selected: check(position, 'cn')}"
                  (click)="select(position, 'cn')">
                  <label [ngClass]="{'red-font': !position.valid_cn}">
                    {{ position.release_cn }}
                  </label>
                </td>
              }
              @if (valid('cn')) {
                <td class="alri bold" [ngClass]="{selected: check(position, 'cn')}"
                  (click)="select(position, 'cn')">
                  <label [ngClass]="{'red-font': !position.valid_cn}">
                    @if (!position.valid_cn) {
                      <i class="fa fa-warning"></i>
                    }
                    {{ position.cn.price }}
                    @if (position.cn) {
                      <span>€</span>
                    }
                  </label>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-md-12">
        @if (('task.change'|HasPerm)) {
          <button class="btn btn-success"
            [disabled]="clicked === null"
            (click)="create()"
              ngbTooltip="Der Auftrag wird für die ausgewählte Position erstellt.
                  Der Vorgang kann nicht rückgängig gemacht werden!">
            Auftrag erstellen
          </button>
        }
      </div>
    </div>
    <div class="row" style="margin: 20px 0;">
      <div class="col-md-12">
        <h3>Kunde</h3>
      </div>
      <div class="col-md-6 customer-inside">
        <h4>{{ data.customer.name }}</h4>
        <p>{{ data.customer.invoice.street }}</p>
        <p>{{ data.customer.invoice.zip }} {{ data.customer.invoice.city }}</p>
        <p>{{ data.customer.invoice.country }}</p>
      </div>
      @if (data.contact) {
        <div class="col-md-6 customer-inside">
          {{ data.contact.title }}
          <h4>{{ data.contact.first_name }} {{ data.contact.last_name }}</h4>
          @if (data.contact.position) {
            <p>{{ data.contact.position }}</p>
          }
          @if (data.contact.phone) {
            <p><i class="fa fa-phone"></i>{{ data.contact.phone }}</p>
          }
          @if (data.contact.mobile) {
            <p><i class="fa fa-mobile"></i>{{ data.contact.mobile }}</p>
          }
          @if (data.contact.mail) {
            <p><i class="fa fa-envelope"></i>{{ data.contact.mail }}</p>
          }
        </div>
      }
      @if (!data.contact) {
        <div class="col-md-6">
          Kein Ansprechpartner ausgewählt
        </div>
      }
    </div>
    <h3>Vertriebsnotiz</h3>
    @if (data.customer) {
      <div>
        <pre id="sales_note">
          {{ data.customer.sales_note }}
        </pre>
      </div>
    }
    @if (data.article.sds_nr?.indexOf('-c') > 0 || data.article.sds_nr?.indexOf('-C') > 0) {
      <div class="row">
        <div class="col-sm-12">
          <div class="alert alert-danger">
            <i class="fa fa-warning"></i> <strong>Achtung!</strong>
            China Artikel: {{ data.article.sds_nr }}
          </div>
        </div>
      </div>
    }
  </div>
}
